import { ActionSteps } from "./ActionSteps";
import { useArea } from "./AreaStep";
import { FormStepCard } from "./FormStepCard";
import { useActionStepsAIHintsQuery } from "./SetActionStepsStep";
import { SESSION_FIELDS } from "./constants";

export const DEFAULT_VALUE_ROW = [{ label: "", date: null }];

export const ActionStepsStep = ({ step, stepper, data, submitDisabled }) => {
  const valueArr = data[SESSION_FIELDS.AREA_OF_DEVELOPMENT];
  const { areaText } = useArea({ valueArr });
  const actionStepsAIHintsQuery = useActionStepsAIHintsQuery({
    areaOfDevelopment: areaText,
    longTermGoal: data[SESSION_FIELDS.LONG_TERM_GOAL],
  });
  const actionStepsHints = [].concat(actionStepsAIHintsQuery.data || []);

  return (
    <FormStepCard
      {...{
        step,
        stepper,
        data: {
          ...data,
          [SESSION_FIELDS.ACTION_STEPS]: data[SESSION_FIELDS.ACTION_STEPS]
            ?.length
            ? data[SESSION_FIELDS.ACTION_STEPS]
            : DEFAULT_VALUE_ROW,
        },
        submitDisabled,
      }}
    >
      <ActionSteps
        name={SESSION_FIELDS.ACTION_STEPS}
        rules={{ required: true, minLength: 1 }}
        hints={actionStepsHints}
        hintsLoading={actionStepsAIHintsQuery.isPending}
        sx={{ my: 5 }}
      />
    </FormStepCard>
  );
};
